import Card from "../UI/Card";
import classes from "./Contact.module.css";

import {
  faPhoneAlt,
  faEnvelope,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";

import ContactDetail from "./ContactDetail";

const Contact = (props) => {
  return (
    <Card color={props.color}>
      <div id="contact" className={classes.wrapper}>
        <div className={classes.info}>
          <h1 className={classes.title}>
            {props.name ? props.name : "Contact"}
          </h1>
          <ul>
            <li>
              <ContactDetail
                type={faPhoneAlt}
                field1={props.phones[0]}
                field2={props.phones[1]}
                field3={props.phones[2]}
              />
            </li>
            <li>
              <ContactDetail
                type={faEnvelope}
                field1={props.emails[0]}
                field2={props.emails[1]}
                field3={props.emails[2]}
              />
            </li>
            <li>
              <ContactDetail
                type={faMapPin}
                field1={
                  <a href={props.map_link[0]} target="_blank" rel="noreferrer">
                    {props.location[0]}
                  </a>
                }
                field2={
                  <a href={props.map_link[1]} target="_blank" rel="noreferrer">
                    {props.location[1]}
                  </a>
                }
                field3={
                  <a href={props.map_link[2]} target="_blank" rel="noreferrer">
                    {props.location[2]}
                  </a>
                }
              />
            </li>
          </ul>
        </div>
        <div className={classes.image}>
          <h1 className={classes.title}>{props.proj_code}</h1>
          <img src={props.image} alt="" />
        </div>
      </div>
    </Card>
  );
};

export default Contact;
